import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const PARAM = 'step';
export function useActiveStep() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const stepId = searchParams.get(PARAM) || undefined;

  const setActiveStep = useCallback(
    async (_stepId?: string) => {
      const newSearchParams = new URLSearchParams(searchParams);
      if (_stepId) {
        newSearchParams.set(PARAM, _stepId);
      } else {
        newSearchParams.delete(PARAM);
      }
      // Selecting a step is an inspection state, not a navigation boundary.
      // Keep browser history for entering/leaving a module, but do not make
      // every selected root or internal step another Back-button destination.
      await navigate({ search: newSearchParams.toString() }, { replace: true });
    },
    [navigate, searchParams],
  );

  return { stepId, setActiveStep };
}
